<template>
  <div class="wrap">
    <div class="handle-wrap">
      <h2 class="title">{{ currnetCustomer }}</h2>
      <div class="page">
        <span>共{{ totalCounts }}条</span>
        <Page
          :total="totalCounts"
          :page-size="limit"
          @on-change="loadCalcSalesCostAnalyze"
          show-total
          simple
        />
      </div>
    </div>
    <div class="card-wrap">
      <div
        class="card-item"
        v-for="(item, index) in salesCostAnalyze"
        :value="item._id"
        :key="item._id"
      >
        <Card style="width: 350px">
          <p slot="title" class="card-title">
            <span class="cacl-date"
              >{{ dayjs(item.createdAt, "title") }} 核算</span
            >
            <Button class="btn" :data-clipboard-text="con" @click="copy(item)"
              >复制数据</Button
            >
          </p>
          <div class="card-info">
            <div class="recipe-NoId row">
              <div class="row-key">配方编号</div>
              <div class="row-value">#{{ item.recipe.NoId }}</div>
            </div>
            <div class="recipe-createdAt row">
              <div class="row-key">配方时间</div>
              <div class="row-value">
                {{ dayjs(item.recipe.createdAt, "recipe") }}
              </div>
            </div>
            <div class="recipe-created row">
              <div class="row-key">配方创建者</div>
              <div class="row-value">
                {{ item.recipe.createdBy ? item.recipe.createdBy.name : "" }}
              </div>
            </div>
            <div class="recipe-verify row">
              <div class="row-key">配方审核者</div>
              <div class="row-value">
                {{ item.recipe.verifiedBy ? item.recipe.verifiedBy.name : "-" }}
              </div>
            </div>
          </div>
          <Row class="table-heade">
            <Col span="8" class="material-heade">材料</Col>
            <Col span="4" class="ratio-heade">比例</Col>
            <Col span="4" class="unitCost-heade">单价</Col>
            <Col span="4" class="price-heade">价格</Col>
            <Col span="4" class="UoD-heade">涨跌</Col>
          </Row>
          <div v-if="item.materialCostDetail">
            <Row
              class="material-wrap"
              v-for="material in item.materialCostDetail"
              :value="material._id"
              :key="material._id"
            >
              <Col span="8" class="material-model">{{
                material.material.model
                  ? material.material.model
                  : material.material.name
              }}</Col>
              <Col span="4" class="ratio">{{
                (material.ratio * 100).toFixed(2) + "%"
              }}</Col>
              <Col span="4" class="ratio">{{
                parseInt(material.calcUnitCost)
              }}</Col>
              <Col span="4" class="price">{{
                parseInt(material.materialCost)
              }}</Col>
              <Col
                span="4"
                class="UoD"
                :style="materialDiffStyle(material.material.diff)"
                >{{ material.material.diff }}</Col
              >
            </Row>
          </div>
          <div v-else>暂无配方数据...</div>
          <Row class="total-wrap">
            <Col span="8" class="total-key">合计</Col>
            <Col span="3" class="total-ratio">100%</Col>
            <Col span="7" class="total-price">{{
              parseInt(item.materialCost)
            }}</Col>
            <Col span="3" class="total-UoD">-</Col>
          </Row>
          <div class="cost-wrap">
            <Row class="semiFactory row">
              <Col span="17" class="cost-semiFactory">母液工厂</Col>
              <Col span="7" class="cost-value">{{ item.factory.name }}</Col>
            </Row>
            <CalcCostInfoRow
              field="材料总成本"
              :value="item.materialCost"
              :diffValue="item.diff.materialCost"
            />
            <CalcCostInfoRow
              field="运费"
              :value="item.transCost"
              :diffValue="item.diff.transCost"
            />
            <CalcCostInfoRow
              field="业务费"
              :value="item.promoFee"
              :diffValue="item.diff.promoFee"
            />
            <CalcCostInfoRow
              field="复配费"
              :value="item.manufactCost"
              :diffValue="item.diff.manufactCost"
            />
            <CalcCostInfoRow
              field="税费"
              :value="item.tax"
              :diffValue="item.diff.tax"
            />
            <CalcCostInfoRow
              field="合计成本"
              :value="item.totalCost"
              :diffValue="item.diff.totalCost"
            />
            <CalcCostInfoRow
              field="售价"
              :value="item.price"
              :diffValue="item.diff.price"
              :typeTwo="true"
            />
            <CalcCostInfoRow
              field="利润"
              :value="item.profit"
              :diffValue="item.diff.profit"
              :typeTwo="true"
            />
            <CalcCostInfoRow
              field="利润率"
              :value="item.profitRate"
              :diffValue="item.diff.profitRate"
              :isPercentage="true"
              :typeTwo="true"
            />
            <CalcCostInfoRow
              field="账期（月）"
              :value="item.estAging"
              :diffValue="item.diff.estAging"
            />
            <CalcCostInfoRow
              field="资金成本"
              :value="item.agingCost"
              :diffValue="item.diff.agingCost"
            />
            <CalcCostInfoRow
              field="合计成本（含资）"
              :value="item.totalCostWithAging"
              :diffValue="item.diff.totalCostWithAging"
            />
            <CalcCostInfoRow
              field="利润（含资）"
              :value="item.profitAfterAging"
              :diffValue="item.diff.profitAfterAging"
              :typeTwo="true"
            />
            <CalcCostInfoRow
              field="利润率（含资）"
              :value="item.profitRateAfterAging"
              :diffValue="item.diff.profitRateAfterAging"
              :isPercentage="true"
              :typeTwo="true"
            />
            <CalcCostInfoRow
              field="年收益率"
              :value="item.annualizedRateOfReturns"
              :diffValue="item.diff.annualizedRateOfReturns"
              :isPercentage="true"
              :typeTwo="true"
            />
          </div>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import CalcCostInfoRow from "./CalcCostInfoRow.vue";
import dayjs from "dayjs";
import Clipboard from "clipboard";
import _ from "lodash";
import { arrayIntersection } from "@/utils";

export default {
  name: "CaclSalesCostAnalyze",
  data() {
    return {
      currnetSalesId: undefined,
      currnetCustomer: undefined,
      currnetSlesAbbr: undefined,
      salesCostAnalyze: [],
      totalCounts: null,
      page: 0,
      filterQuery: {},
      limit: 10,
      con: null,
    };
  },
  components: {
    CalcCostInfoRow,
  },
  computed: {},
  created() {
    const data = this.$route.query;
    this.currnetSalesId = data.id;
    this.currnetCustomer = data.customer;
    this.currnetSlesAbbr = data.abbr;
    this.loadCalcSalesCostAnalyze();
  },
  methods: {
    arrayIntersection(array, targetArray) {
      return arrayIntersection(array, targetArray);
    },
    adjustDiffNumber(params, numberString, appendString) {
      let value = _.get(params, numberString, "-");
      let add = "";
      if (value > 0) {
        add = "+";
      } else if (value == 0) {
        value = "-";
      }
      if (typeof value === "number") {
        return appendString
          ? add + (value * 100).toFixed(2) + appendString
          : add + value.toFixed(0);
      } else if (typeof value === "string") {
        return "-";
      }
    },
    adjustNumber(params, numberString, appendString) {
      const value = _.get(params, numberString, "");
      if (typeof value === "number") {
        return appendString
          ? (value * 100).toFixed(2) + appendString
          : value.toFixed(0);
      } else if (typeof value === "string") {
        return "";
      }
    },
    ...mapActions({
      getCalcSalesCostAnalyzeByID:
        "caclSalesCost/getCalcSalesCostAnalyzeByIDAction",
    }),
    async loadCalcSalesCostAnalyze(page) {
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        limit: this.limit,
        skip: this.page * this.limit,
      };
      const data = await this.getCalcSalesCostAnalyzeByID({
        id: this.currnetSalesId,
        data: this.filterQuery,
      });
      this.totalCounts = data.totalCounts;
      this.salesCostAnalyze = data.salesCostList;
      this.calcUpAndDownMethod();
    },
    dayjs(time, type) {
      if (type === "title") {
        return dayjs(time).format("MM月DD日");
      } else if (type === "recipe") {
        return dayjs(time).format("YYYY-MM-DD HH:mm");
      }
    },
    materialDiffStyle(diffRatio) {
      const style = { color: "black" };
      if (diffRatio > 0) {
        style.color = "rgba(150,0,0,0.7)";
      } else if (diffRatio < 0) {
        style.color = "rgba(0,150,0,0.7)";
      } else {
        style.color = "lightgray";
      }
      return style;
    },
    calcUpAndDownMethod() {
      for (let i = 0; i < this.salesCostAnalyze.length; i++) {
        if (i === this.salesCostAnalyze.length - 1) {
          this.salesCostAnalyze[i].diff = {};
          break;
        }
        this.salesCostAnalyze[i].diff = {};
        const diffField = [
          "materialCost",
          "manufactCost",
          "tax",
          "transCost",
          "promoFee",
          "totalCost",
          "price",
          "profit",
          "profitRate",
          "estAging",
          "agingCost",
          "profitAfterAging",
          "profitRateAfterAging",
        ];
        diffField.forEach((field) => {
          this.salesCostAnalyze[i].diff[field] =
            (this.salesCostAnalyze[i][field] ?? 0) -
            (this.salesCostAnalyze[i + 1][field] ?? 0);
        });
        this.salesCostAnalyze[i].materialCostDetail.forEach((citem) => {
          this.salesCostAnalyze[i + 1].materialCostDetail.forEach((nitem) => {
            if (citem.material._id === nitem.material._id) {
              citem.material.diff = (
                citem.materialCost - nitem.materialCost
              ).toFixed(2);
            }
          });
        });
      }
    },
    diffClass(v, typeTwo) {
      if (v > 0) {
        return typeTwo ? "blue" : "red";
      } else if (v < 0) {
        return typeTwo ? "orange" : "green";
      }
    },
    copy(salesCost) {
      this.con = `${dayjs(salesCost.createdAt).format("MM月DD日")}核算
客户：${this.currnetCustomer}
销售项目：${this.currnetSlesAbbr}
配方编号：#${salesCost.recipe.NoId} ${salesCost.recipe.name}
工厂：${salesCost.factory.name}
材料总成本：${this.adjustNumber(salesCost, "materialCost")}
运费：${this.adjustNumber(salesCost, "transCost")}
业务费：${this.adjustNumber(salesCost, "promoFee")}
复配加工费：${this.adjustNumber(salesCost, "manufactCost")}
税费：${this.adjustNumber(salesCost, "tax")}
总成本：${this.adjustNumber(salesCost, "totalCost")}
价格：${this.adjustNumber(salesCost, "price")}
利润：${this.adjustNumber(salesCost, "profit")}
利润率：${this.adjustNumber(salesCost, "profitRate", "%")}
预计账龄（月）：${this.adjustNumber(salesCost, "estAging")}
资金成本：${this.adjustNumber(salesCost, "agingCost")}
资本后利润：${this.adjustNumber(salesCost, "profitAfterAging")}
资本后利润率：${this.adjustNumber(salesCost, "profitRateAfterAging", "%")}
年收益率：${this.adjustNumber(salesCost, "annualizedRateOfReturns", "%")}
`;
      this.copyMethod();
    },
    // 调用copy的方法
    copyMethod() {
      let clipboard = new Clipboard(".btn");
      clipboard.on("success", (e) => {
        this.$Message.success("已复制到剪切板");
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        clipboard.destroy();
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
.wrap
  overflow-y auto

.handle-wrap
  display flex
  justify-content space-between

.page
  margin-right 200px
  display flex
  align-items center

.title, .card-item
  margin-bottom 20px

.card-title
  height 35px
  padding 0
  display flex
  justify-content space-between

.cacl-date
  line-height 35px

.card-wrap
  display flex
  flex-wrap wrap

.card-item
  margin-right 35px

.row, .material-wrap, .total-wrap
  display flex
  justify-content space-between

.material-wrap:nth-child(even)
  background-color #f1f1f1

.material-heade ~ div, .material-model ~ div, .total-key ~ div, .cost-key ~ div
  text-align right
</style>